<template>
  <div class="about"></div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  data() {
    return {
      values: {},
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    let url = window.location.hash.split('?')[1];
    let arr = url.split('&');
    arr.forEach(item => {
      let str = item.split('=');
      this.values[str[0]] = decodeURIComponent(str[1]);
    });
    this.setUserInfo(this.values);
    this.handleGet();
  },
  methods: {
    ...mapMutations({
      setUserInfo: 'SET_USER_INFO',
    }),
    handleGet() {
      if (this.values.is_jieshun == 1) {
        if (this.values.in_or_out === '0') {
          this.$router.push({
            name: 'jieshunEnter',
          });
        } else {
          if (this.values.plateType == 1) {
            this.$router.push({
              name: 'jieshunHome',
            });
          } else {
            this.$router.push({
              name: 'jieshununlicensed',
            });
          }
        }
      } else {
        if (this.values.in_or_out === '0') {
          this.$router.push({
            name: 'Enter',
          });
        } else {
          this.$router.push({
            name: 'Home',
          });
        }
      }
    },
  },
};
</script>
